import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Inner_Summary_Card.css";

function Inner_Summary_Card({
  item,
  icons,
  // mainImage,
  // changeMainImage,
  // index,
  // hideImages = false,
}) {
  const [activeMeal, setActiveMeal] = useState("breakfast");

  return (
    <div className="itinerary_card Inner_Summary_Card">
      <div className="day_card">
        {/* Transfer Section */}
        <div className="section_box">
          <div className="section_title">
            <img src={icons?.car} className="icon_img" alt="" />
            {item?.transferType}
          </div>

          <div className="transfer_mode">{item?.transferMode}</div>

          <div className="route_section">
            <div className="route_box">
              <p className="route_label">From</p>
              <div className="route_place">
                <img
                  src="/assets/images/cruise/itenarary/flight.png"
                  className="route_icon"
                  alt=""
                />
                {item?.ship_from}
              </div>
            </div>

            <div className="route_middle">
              <div className="route_line"></div>
            </div>

            <div className="route_box">
              <p className="route_label">To</p>
              <div className="route_place">
                <img
                  src="/assets/images/cruise/itenarary/hotel.png"
                  className="route_icon"
                  alt=""
                />
                {item?.to}
              </div>
            </div>
          </div>
        </div>

        {/* Stay Section */}
        <div className="section_box">
          <div className="section_title">
            <img src={icons?.bed} className="icon_img" alt="" />
            Stay at
          </div>
          <div className="hotel_name">
            Stay at {item?.hotel}
            <span className="hotel_rating"></span>
          </div>
          <div className="check_row">
            <span>
              Check In <b>{item?.check_in}</b>
            </span>

            {/* <span>{item?.nights}</span> */}

            <span>
              Check Out <b>{item?.check_out}</b>
            </span>
          </div>

          {!item && (
            <div className="inclusion_wrapper">
              <div className="inclusion_card">
                <div className="inclusion_left">
                  <h6>Standard</h6>
                  <p>Inclusions:</p>
                </div>

                <div className="inclusion_items">
                  <div
                    className={`inclusion_item ${
                      activeMeal === "breakfast" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("breakfast")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img1.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Breakfast</p>
                    <span className="inner_text">Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "lunch" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("lunch")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img2.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Lunch</p>
                    <span className="inner_text">Not Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "dinner" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("dinner")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img3.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Dinner</p>
                    <span className="inner_text">Not Included</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Inner_Summary_Card;
